import React from 'react';
import cx from './cx';

const AppInput = React.forwardRef(({ className = '', size, ...rest }, ref) => (
  <input
    ref={ref}
    className={cx('form-control', size === 'sm' && 'form-control-sm', className)}
    {...rest}
  />
));

AppInput.displayName = 'AppInput';

export default AppInput;
